import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Martlet chrome/tokens come from @martletai/ui + @martletai/design-tokens (declared in
// package.json). Their exact stylesheet/shell export path is wired in the build phase (the API
// is confirmed on install against 182); the launcher below is the SDK embed and is the point.
const el = document.getElementById('root');
if (el) createRoot(el).render(<React.StrictMode><App /></React.StrictMode>);
